import MoreMobileMeals from "./screens/more/MoreMobileMeals.vue";
import MoreMobileDishes from "./screens/more/MoreMobileDishes.vue";
import MoreMobileEmployees from "./screens/more/MoreMobileEmployees.vue";
import MoreMobileWorkerItems from "./screens/more/MoreMobileWorkerItems.vue";
import MoreMobileCredit from "./screens/more/MoreMobileCredit.vue";
import MoreMobileCreditUser from "./screens/more/MoreMobileCreditUser.vue";
import MoreMobilePackages from "./screens/more/MoreMobilePackages.vue";

/** Ključevi izveštaja prikaza "Firme koje hrani restoran" (meni, redom po grupama). */
export const MORE_MENU = {
  kitchen: ["moreMeals", "moreDishes"],
  orders: ["moreEmployees", "moreWorkerItems", "moreCredit"],
  handout: ["morePacking", "moreTaken"],
};

/** Nije u meniju: narudžbe kreditnog korisnika po mesecima, otvara se iz liste kreditnih korisnika. */
export const CREDIT_USER_SCREEN = "creditUser";

/**
 * Izveštaji prikaza "Firme koje hrani restoran" na telefonu. `vm` je ljuska (ReportMobile): odatle su prevodi i
 * kreditni korisnik koji je izabran u listi. Firme su iz spiska firmi sa ugovorom "više restorana"
 * (`companySource: "multi"`), a izbor firmi deli mesto sa izborom prikaza 1.
 */
export const buildMoreScreens = (vm) => ({
  moreMeals: {
    title: vm.$t("meals"),
    subtitle: vm.$t("report_mobile.hints.meals"),
    icon: "mdi-bowl-mix-outline",
    component: MoreMobileMeals,
    companies: true,
    shifts: true,
    headerSearch: true,
  },
  moreDishes: {
    title: vm.$t("meals_main"),
    subtitle: vm.$t("report_group.hints.meals"),
    icon: "mdi-pot-steam-outline",
    component: MoreMobileDishes,
    companies: true,
    shifts: true,
    headerSearch: true,
  },
  moreEmployees: {
    title: vm.$t("employees"),
    subtitle: vm.$t("report_mobile.hints.employees"),
    icon: "mdi-account-outline",
    component: MoreMobileEmployees,
    companies: "single",
    shifts: true,
    headerSearch: true,
  },
  moreWorkerItems: {
    title: vm.$t("more_restaurants_report.worker_items_tab"),
    subtitle: vm.$t("report_mobile.hints.worker_orders"),
    icon: "mdi-account-details-outline",
    component: MoreMobileWorkerItems,
    companies: "single",
    shifts: true,
    headerSearch: true,
  },
  moreCredit: {
    title: vm.$t("credit_users"),
    subtitle: `${vm.$t("spent_on_credits")} · ${vm.$t("credit_balance")}`,
    icon: "mdi-account-cash-outline",
    component: MoreMobileCredit,
    companies: "single",
    headerSearch: true,
  },
  morePacking: {
    title: vm.$t("pak"),
    subtitle: vm.$t("report_mobile.hints.packages"),
    icon: "mdi-shopping-outline",
    component: MoreMobilePackages,
    props: { packing: true },
    companies: true,
    shifts: true,
    headerSearch: true,
    header: "summary",
  },
  moreTaken: {
    title: vm.$t("taken_meals"),
    subtitle: vm.$t("report_group.hints.taken"),
    icon: "mdi-food-takeout-box-outline",
    component: MoreMobilePackages,
    companies: true,
    shifts: true,
    headerSearch: true,
    header: "summary",
  },
  [CREDIT_USER_SCREEN]: {
    title: (vm.employeeContext && vm.employeeContext.fullName) || vm.$t("credit_users"),
    subtitleText: vm.employeeSubtitle,
    component: MoreMobileCreditUser,
    header: "worker",
    noExcel: true,
  },
});
